import { NgModule } from '@angular/core';
import { StorageComponent } from './storage.component';



@NgModule({
  declarations: [StorageComponent],
  imports: [
  ],
  exports: [StorageComponent]
})
export class NgStorageModule { }
